import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { getFormattedDegreeData } from "shared/helpers/profile/getFormattedDegreeData";
import { ProfileView } from "shared/mappers/database/profile/profile";
import { SocietyTagView } from "shared/mappers/database/tag/society-tag";
import { DeepKeys } from "shared/types/deepkeys";

export type PillarTableColumnProfileTagProps<T> = {
  property: keyof SocietyTagView;
  matching?: string | string[];
  outputTrue?: string;
  outputFalse?: string;
} & PillarTableBaseColumnCellValuePathProps<T> &
  ComponentPropsWithoutRef<"div">;

const PillarTableColumnProfileTag = <T,>({
  cellValuePath,
  property,
  matching,
  outputTrue,
  outputFalse,
  ...props
}: PillarTableColumnProfileTagProps<T>) => {
  const { rowValue } = usePillarTableRowContext();
  const profile = cellValuePath
    ? (lodashGet(rowValue, cellValuePath) as ProfileView)
    : (rowValue as ProfileView);
  const tags = profile.tags;
  if (matching) {
    if (!Array.isArray(matching)) {
      matching = [matching];
    }
    const foundTag = tags?.find(
      (tag) =>
        Array.isArray(matching) &&
        matching.some((match) => tag[property] === match),
    );
    if (outputTrue && foundTag) {
      return <>{outputTrue ?? ""}</>;
    }
    if (outputFalse && !foundTag) {
      return <>{outputFalse ?? ""}</>;
    }
    return <>{(foundTag ? foundTag[property]?.toString() : "") ?? ""}</>;
  }
  return <>{tags?.map((tag) => tag[property]?.toString()).join(", ") ?? ""}</>;
};
export default PillarTableColumnProfileTag;
